import {
  AlphabetFilterSchema,
  SearchFilterSchema,
} from '@vs-shop/schemas/url/queryParams/brandFilters';
import {
  alphabetFilterParamName,
  pageParamName,
  searchFilterParamName,
} from '@vs-shop/schemas/config/urlParams';
import { PageSchema } from '@vs-shop/schemas/url/queryParams/pagination';
import { Effect, Option } from 'effect';

import { RuntimeClientAtom } from '../../runtime/RuntimeClient';
import * as Atom from 'effect/unstable/reactivity/Atom';

// Page search param atom with URL synchronization
export const pageSearchParamAtom = Atom.searchParam(pageParamName, {
  schema: PageSchema,
}).pipe(Atom.withServerValue(() => Option.none()));

// Alphabet filter search param atom with URL synchronization
export const alphabetFilterSearchParamAtom = Atom.searchParam(alphabetFilterParamName, {
  schema: AlphabetFilterSchema,
}).pipe(Atom.withServerValue(() => Option.none()));

// Search filter search param atom with URL synchronization
export const searchFilterSearchParamAtom = Atom.searchParam(searchFilterParamName, {
  schema: SearchFilterSchema,
}).pipe(Atom.withServerValue(() => Option.none()));

// Load more pages counter (0 = show only current page, 1 = show current + next, etc.)
export const loadMorePagesAtom = Atom.make(0);

// Current page atom with default value
export const currentPageAtom = Atom.map(pageSearchParamAtom, (pageOption) =>
  Option.getOrElse(pageOption, () => 1)
);

// Current alphabet filter atom (null if not set)
export const currentAlphabetFilterAtom = Atom.map(alphabetFilterSearchParamAtom, (filterOption) =>
  Option.getOrElse(filterOption, () => null)
);

// Current search filter atom (null if not set)
export const currentSearchFilterAtom = Atom.map(searchFilterSearchParamAtom, (filterOption) =>
  Option.getOrElse(filterOption, () => null)
);

// Last page loaded including load-more pages
export const lastPageLoadedIncludingLoadMoreAtom = Atom.readable((ctx) => {
  const page = ctx.get(currentPageAtom);
  const loadMorePages = ctx.get(loadMorePagesAtom);

  return page + loadMorePages;
});

// Type for page change function (compatible with generic pagination component)
export type ChangeBrandPageAtomPromise = (
  value: number | typeof Atom.Reset | typeof Atom.Interrupt
) => Promise<void>;

// Function atom to change page (resets load-more counter)
export const changeBrandPageAtomFn = RuntimeClientAtom.fn(
  (page: number, ctx) =>
    Effect.gen(function* () {
      yield* Effect.logDebug('🔄 changeBrandPageAtomFn', page);
      ctx.set(pageSearchParamAtom, Option.some(page));
      ctx.set(loadMorePagesAtom, 0);
    }),
  {
    // reactivityKeys: [createBrandReactivityKey.brands()],
  }
);
